export default "__VITE_ASSET__4b19e3cc__"